module.exports = __webpack_public_path__ + "img/CEU.d5545400.svg";